import { ReactNode } from 'react'
import { useAlertPopupsContext } from 'context/AlertPopups'

interface IConfirmationOptions {
  title: string | ReactNode
  description?: string | ReactNode
  imageSrc?: string
  confirmButtonText: string
  cancelButtonText?: string
  onConfirm: () => void
  onCancel?: () => void
}

export const useConfirmationPopup = () => {
  const { setAlertPopupsData } = useAlertPopupsContext()

  const showConfirmation = ({
    title,
    description,
    imageSrc,
    confirmButtonText,
    cancelButtonText = 'Cancel',
    onConfirm,
    onCancel
  }: IConfirmationOptions) => {
    setAlertPopupsData({
      confirmationPopup: {
        title,
        description,
        imageSrc,
        buttons: {
          cancel: cancelButtonText
            ? {
                label: cancelButtonText,
                onClick: onCancel
              }
            : undefined,
          confirm: {
            label: confirmButtonText,
            onClick: onConfirm
          }
        }
      }
    })
  }

  return showConfirmation
}
